export const ROUTE_ABOUT_US = "/aboutUs";
export const ROUTE_CONDITIONS = "/conditions";
export const ROUTE_CODE_OF_CONDUCT = "/codeOfConduct";
export const ROUTE_CFP = "/cfp";
export const ROUTE_COMMUNITIES = "/communities";
export const ROUTE_COOKIES = "/cookies";
export const ROUTE_DIVERSITY = "/diversity";
export const ROUTE_HOME = "/";
export const ROUTE_ATTENDEE = "/attendee";

export const ROUTE_KCD = "/kcd";
export const ROUTE_HOME_ALTERNATE = "/website";
export const ROUTE_JOB_OFFERS = "/jobOffers";
export const ROUTE_SCHEDULE = "/schedule";
export const ROUTE_SPEAKERS = "/speakers";

export const ROUTE_SPONSORSHIP = "/sponsorship";
export const ROUTE_SPEAKER_DETAIL = "/speaker";
export const ROUTE_SPEAKER_INFO = "/speaker-information";
export const ROUTE_SPEAKER_DETAIL_PLAIN = "/speaker/:id";
export const ROUTE_TALKS = "/talks";
export const ROUTE_SESSION_FEEDBACK = "/session-feedback";
export const ROUTE_TALK_DETAIL = "/talk";
export const ROUTE_WORKSHOPS = "/workshops";
export const ROUTE_MEETING_DETAIL_PLAIN = "/talk/:id";
export const ROUTE_TRAVEL = ":id/travel";
export const ROUTE_ACCOMMODATION = "/accommodation";

// 2026

export const ROUTE_2026_ATTENDEE = "/2026/attendee";
export const ROUTE_2026_CFP = "/2026/cfp";
export const ROUTE_2026_COMMUNITIES = "/2026/communities";
export const ROUTE_2026_DIVERSITY = "/2026/diversity";
export const ROUTE_2026_HOME = "/2026";
export const ROUTE_2026_JOB_OFFERS = "/2026/jobOffers";
export const ROUTE_2026_SCHEDULE = "/2026/schedule";
export const ROUTE_2026_SESSION_FEEDBACK = "/2026/session-feedback";
export const ROUTE_2026_SPEAKERS = "/2026/speakers";
export const ROUTE_2026_SPEAKER_DETAIL = "/2026/speaker";
export const ROUTE_2026_SPEAKER_DETAIL_PLAIN = "/2026/speaker/:id";
export const ROUTE_2026_SPEAKER_INFO = "/2026/speaker-information";
export const ROUTE_2026_TALKS = "/2026/talks";
export const ROUTE_2026_TALK_DETAIL = "/2026/talk";
export const ROUTE_2026_TALK_DETAIL_PLAIN = "/2026/talk/:id";
export const ROUTE_2026_CODE_OF_CONDUCT = "/2026/codeOfConduct";
export const ROUTE_2026_SPONSORSHIP = "/2026/sponsorship";
export const ROUTE_2026_TRAVEL = "/2026/travel";
export const ROUTE_2026_WORKSHOPS = "/2026/workshops";

// 2025

export const ROUTE_2025_ATTENDEE = "/2025/attendee";
export const ROUTE_2025_CFP = "/2025/cfp";
export const ROUTE_2025_COMMUNITIES = "/2025/communities";
export const ROUTE_2025_DIVERSITY = "/2025/diversity";
export const ROUTE_2025_HOME = "/2025";
export const ROUTE_2025_JOB_OFFERS = "/2025/jobOffers";
export const ROUTE_2025_SCHEDULE = "/2025/schedule";
export const ROUTE_2025_SESSION_FEEDBACK = "/2025/session-feedback";
export const ROUTE_2025_SPEAKERS = "/2025/speakers";
export const ROUTE_2025_SPEAKER_DETAIL = "/2025/speaker";
export const ROUTE_2025_SPEAKER_DETAIL_PLAIN = "/2025/speaker/:id";
export const ROUTE_2025_SPEAKER_INFO = "/2025/speaker-information";
export const ROUTE_2025_TALKS = "/2025/talks";
export const ROUTE_2025_TALK_DETAIL = "/2025/talk";
export const ROUTE_2025_TALK_DETAIL_PLAIN = "/2025/talk/:id";
export const ROUTE_2025_WORKSHOPS = "/2025/workshops";

// 2023

export const ROUTE_2023_ATTENDEE = "/2023/attendee";
export const ROUTE_2023_CFP = "/2023/cfp";
export const ROUTE_2023_COMMUNITIES = "/2023/communities";
export const ROUTE_2023_DIVERSITY = "/2023/diversity";
export const ROUTE_2023_HOME = "/2023";
export const ROUTE_2023_JOB_OFFERS = "/2023/jobOffers";
export const ROUTE_2023_SCHEDULE = "/2023/schedule";
export const ROUTE_2023_SESSION_FEEDBACK = "/2023/session-feedback";
export const ROUTE_2023_SPEAKERS = "/2023/speakers";
export const ROUTE_2023_SPEAKER_DETAIL = "/2023/speaker";
export const ROUTE_2023_SPEAKER_DETAIL_PLAIN = "/2023/speaker/:id";
export const ROUTE_2023_SPEAKER_INFO = "/2023/speaker-information";
export const ROUTE_2023_TALKS = "/2023/talks";
export const ROUTE_2023_TALK_DETAIL = "/2023/talk";
export const ROUTE_2023_TALK_DETAIL_PLAIN = "/2023/talk/:id";
export const ROUTE_2023_WORKSHOPS = "/2023/workshops";

// 2024

export const ROUTE_2024_ATTENDEE = "/2024/attendee";
export const ROUTE_2024_CFP = "/2024/cfp";
export const ROUTE_2024_COMMUNITIES = "/2024/communities";
export const ROUTE_2024_DIVERSITY = "/2024/diversity";
export const ROUTE_2024_HOME = "/2024";
export const ROUTE_2024_JOB_OFFERS = "/2024/jobOffers";
export const ROUTE_2024_SCHEDULE = "/2024/schedule";
export const ROUTE_2024_SESSION_FEEDBACK = "/2024/session-feedback";
export const ROUTE_2024_SPEAKERS = "/2024/speakers";
export const ROUTE_2024_SPEAKER_DETAIL = "/2024/speaker";
export const ROUTE_2024_SPEAKER_DETAIL_PLAIN = "/2024/speaker/:id";
export const ROUTE_2024_SPEAKER_INFO = "/2024/speaker-information";
export const ROUTE_2024_TALKS = "/2024/talks";
export const ROUTE_2024_TALK_DETAIL = "/2024/talk";
export const ROUTE_2024_TALK_DETAIL_PLAIN = "/2024/talk/:id";
export const ROUTE_2024_WORKSHOPS = "/2024/workshops";
